import { BigNumberish } from 'ethers';
import { config } from '../../config/config';
import { OrderBookType } from '../../config/constants';
import calculatePriceRange from './calculatePriceRange';
import { toBigNumber } from '../../web3/utils';

const caluclateLimitPrice = (
    isMarketOrder: boolean | undefined,
    orderType: Exclude<OrderBookType, OrderBookType.LIQUIDATED>,
    isShort: boolean,
    limitPrice: string,
    slippage: number,
    decimals: BigNumberish = config.orderBookDecimal
) => {
    const [min, max] = calculatePriceRange(limitPrice, slippage, decimals);

    const userSetPrice = toBigNumber(limitPrice, decimals).toString();

    if (isMarketOrder) {
        return { minPrice: min, maxPrice: max };
    }

    switch (orderType) {
        case OrderBookType.OPEN:
        case OrderBookType.EXTEND:
        case OrderBookType.ADD_MARGIN:
        case OrderBookType.REMOVE_MARGIN:
        case OrderBookType.EXTEND_LEVERAGE:
            return isShort
                ? {
                      minPrice: min,
                      maxPrice: userSetPrice,
                  }
                : {
                      minPrice: userSetPrice,
                      maxPrice: max,
                  };
        case OrderBookType.CLOSE:
        case OrderBookType.PARTIALLY_CLOSE:
            return isShort
                ? {
                      minPrice: userSetPrice,
                      maxPrice: max,
                  }
                : {
                      minPrice: min,
                      maxPrice: userSetPrice,
                  };
        case OrderBookType.TAKE_PROFIT:
            return isShort
                ? {
                      minPrice: '0',
                      maxPrice: userSetPrice,
                  }
                : {
                      minPrice: userSetPrice,
                      maxPrice: '9999999999999999999999999999999999999',
                  };
        case OrderBookType.STOP_LOSS:
            return isShort
                ? {
                      minPrice: userSetPrice,
                      maxPrice: '9999999999999999999999999999999999999',
                  }
                : {
                      minPrice: '0',
                      maxPrice: userSetPrice,
                  };
    }
};

export default caluclateLimitPrice;
